/**
 * 组件引入main配置
 */

import Vue from 'vue';
import I18nUtil from '@didi/i18n-util';
let { getLanguageLong } = I18nUtil;

const currentLang = getLanguageLong();

import Popup from '@/components/Popup/index';
import '@/components/Popup/style.css';
Vue.component(Popup.name, Popup);

import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
} from 'swiper/js/swiper.esm';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
import 'swiper/css/swiper.css';
// Swiper modules
SwiperClass.use([Pagination, Navigation]);
// Global use Swiper
Vue.use(getAwesomeSwiper(SwiperClass));

import CouponUI from '@didi/soda-c-coupon';
import '@didi/soda-c-coupon/lib/coupon.css';
Vue.use(CouponUI);
CouponUI.locale.use(
  require(`@didi/soda-c-coupon/src/locale/lang/${currentLang}`).default
);

import DishFood from '@/components/DishFood/index.js';
import RLoading from '@/components/Loading/index.js';
import CardPopup from '@/components/Pay/cardPopup.js';
import TermsPopup from '@/components/Coupon/termsPopup.js';
import CodePopup from '@/components/Coupon/codePopup.js';
import VirtualTel from '@/components/VirtualTel/index.js';

Vue.prototype.$dishFood = DishFood;
Vue.prototype.$rLoading = RLoading;
Vue.prototype.$cardPopup = CardPopup;
Vue.prototype.$termsPopup = TermsPopup;
Vue.prototype.$codePopup = CodePopup;
Vue.prototype.$virtualTel = VirtualTel;
